import React, { useState } from 'react';
import { Modal, Icon } from '@scale/scaleui';

interface PreviewMetricsModalProps {
  campaignId?: string;
  emailTemplateId?: string;
}

export const PreviewMetricsModal: React.FC<PreviewMetricsModalProps> = ({
  campaignId,
  emailTemplateId,
}: PreviewMetricsModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const srcUrl = emailTemplateId
    ? `https://redash.scale.com/dashboards/8193-event-driven-email-notifications?p_template_id=${encodeURIComponent(
        emailTemplateId,
      )}`
    : `https://redash.scale.com/dashboards/7785-growth-email-campaign-metrics-v3?p_CAMPAIGN_ID=${encodeURIComponent(
        campaignId ?? '',
      )}`;

  return (
    <>
      <Icon icon="external-link-alt" size="sm" onClick={() => setIsOpen(!isOpen)} />

      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title="View Redash Metrics"
        innerClassName={'w-4/5 h-full'}
      >
        <iframe
          src={srcUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          className="overflow-hidden"
        />
      </Modal>
    </>
  );
};
